import Capa from "./Capa";
import { tooltip_municipios } from "@/components/mapa/capas/_utils.js";

const VIH_BASE_LAYER_NAME = "vih:sig_nodos_20221215";

const dic = {
  //id_muestra: 'clave de la muestra',
  cp: "código postal",
  fecha_toma: "fecha de muestra",
  //prueba_vih: 'prueba vih',
  sexo: "sexo",
  edad: "edad",
  seguridad_social: "seguridad social",
  resistencia: "resistencia",
  linfocitos: " linfositos",
  //carga_viral: 'carga viral',
  cvegeomun: "Clave municipal",
};

//
export default class VihBaseConteosFiltros extends Capa {
  _data = [];
  _callbackOnLoad = undefined;
  _callbackOnStartLoad = undefined;
  _columnas_conteos = [];
  columnas_conteos_grafica = {};

  range_columnas = {};

  date_column = "fecha_toma";
  _columnas_conteos_by_date = ["cvegeomun", "cp"];
  conteos_by_date = {};

  constructor(condiciones) {
    super({
      capa: VIH_BASE_LAYER_NAME,
      titulo: "Base Muestra vih",
      z_index: 0,
    });

    this.tooltip = tooltip_municipios;
    this._columnas_conteos = [
      "sexo",
      "seguridad_social",
      "resistencia",
      "edad",
      "cvegeomun",
      "cp",
      "linfocitos",
    ];
    this.range_columnas["edad"] = [[0, 30], [30, 45], [45, 59], [59, "MAX_VALUE"], [null]];

    this.range_columnas["linfocitos"] = [
      [0, 50],
      [50, 100],
      [100, 150],
      [150, 200],
      [200, 250],
      [250, 300],
      [300, 350],
      [350, 400],
      [400, 450],
      [450, 500],
      [500, 550],
      [550, 600],
      [600, 650],
      [650, 700],
      [700, 750],
      [750, 800],
      [800, 850],
      [850, 900],
      [900, 950],
      [950, 1000],
      [1000, 1050],
      [1050, 1100],
      [1100, 1150],
      [1150, 1200],
      [1200, 1250],
      [1250, 1300],
      [1300, 1350],
      [1350, 1400],
      [1400, 1450],
      [1450, 1500],
      //[1000,"MAX_VALUE"]
    ];

    // filtro por defecto
    const condicionesAgrupadas = condiciones.reduce((acum, current) => {
      const campo = current.split("|")[0];
      const condicion = current.split("|")[1];
      if (!(campo in acum)) {
        acum[campo] = [];
      }
      acum[campo].push(condicion);
      return acum;
    }, {});
    let condiciones2 =
      condiciones.length > 0
        ? Object.values(condicionesAgrupadas)
            .map((condicionAgrupada) => {
              return ` (${condicionAgrupada.join("or")} ) `;
            })
            .join("and")
        : "";
    condiciones2 = condiciones2.length > 0 ? `and (${condiciones2})` : "";
    //const condiciones2 = condiciones.length>0 ? ` and (${condiciones.map(cond=>cond.split('|')[1] ).join("or")})` :''
    this.geoserverFiltro = `cp is not null and cvegeomun is not null ${condiciones2}`;
    this.wfs.columnas = Object.keys(dic).join(",");
  }

  onLoadData(callback) {
    this._callbackOnLoad = callback;
  }
  onStartLoadData(callback) {
    this._callbackOnStartLoad = callback;
  }

  loadData() {
    //console.log(this.wfs.url)
    if (typeof this._callbackOnStartLoad === "function") {
      this._callbackOnStartLoad();
    }
    fetch(this.wfs.url)
      .then((response) => response.json())
      .then((data) => {
        this._data = data.features;
        //this._columnas_conteos.forEach(columna=>{
        //  this.preparaConteos(columna)
        //})
        this.preparaConteosporFecha();
        //this.preparaConteos()
        if (typeof this._callbackOnLoad === "function") {
          this._callbackOnLoad();
        }
      });
  }

  preparaConteos(columna) {
    this.columnas_conteos_grafica[columna] = this.conteosXColumna(columna, this._data);
    /*
    if(columna in this.range_columnas){

      this.columnas_conteos_grafica[columna] = this._data.reduce((acum,current)=>{
        const bin = getBinCuantitativeData(this.range_columnas[columna],current.properties[columna])
        //console.log(bin,current.properties[columna])
        if (!(bin in acum)){
          //acum[current.properties[columna]] = 0
          acum[bin] =0
        }
        acum[bin] = acum[bin] + 1
        return acum;
      },{});

      return
    }

    this.columnas_conteos_grafica[columna] = this._data.reduce((acum,current)=>{
      if (!(current.properties[columna] in acum)){
        acum[current.properties[columna]] = 0
      }
      acum[current.properties[columna]] = acum[current.properties[columna]] + 1
      return acum;
    },{});
    */
  }

  conteosXColumna(columna, datos) {
    if (columna in this.range_columnas) {
      return datos.reduce((acum, current) => {
        const bin = getBinCuantitativeData(
          this.range_columnas[columna],
          current.properties[columna]
        );
        //console.log(bin,current.properties[columna])
        if (!(bin in acum)) {
          //acum[current.properties[columna]] = 0
          acum[bin] = 0;
        }
        acum[bin] = acum[bin] + 1;
        return acum;
      }, {});
    }

    return datos.reduce((acum, current) => {
      if (!(current.properties[columna] in acum)) {
        acum[current.properties[columna]] = 0;
      }
      acum[current.properties[columna]] = acum[current.properties[columna]] + 1;
      return acum;
    }, {});
  }

  preparaConteosporFecha() {
    //preparar los dias  entre las fechas
    //this.date_column
    //this._columnas_conteos_by_date
    //this.conteos_by_date

    /**
     * SE DEFINEN DOS FECHAS CONSTANTES PARA NO PERDER RECURSOS EN CALCULAR EL MAXIMO Y EL MINIMO, PERO SI
     * ES NECESARIO HACERLO DINAMICO ES AQUI
     * */
    //const all_dates=this._data.map(row=>row.properties[this.date_column])
    const minDate = new Date(Date.parse("2019-07-17"));
    const maxDate = new Date(Date.parse("2022-12-16"));

    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const dias = (maxDate - minDate) / _MS_PER_DAY;

    //this.conteos_by_date = Object.fromEntries(this._columnas_conteos_by_date.map(item=>[item,{}]));

    for (let i = 0; i < dias; i++) {
      const date_actual = new Date(minDate.getTime());
      date_actual.setDate(minDate.getDate() + i);
      let date_actual_string = date_actual.toISOString().split("T")[0];
      this.conteos_by_date[date_actual_string] = {};
      const data_filtrada = this._data.filter((row) => {
        let fecha1 = Date.parse(row.properties[this.date_column]);
        return fecha1 <= date_actual;
      });

      this._columnas_conteos.forEach((columna) => {
        this.conteos_by_date[date_actual_string][columna] = this.conteosXColumna(
          columna,
          data_filtrada
        );
      });
    }

    this._columnas_conteos_by_date.forEach((columna) => {});
  }
}

/**
 * Genera las condiciones de igualdad , con el array de valores checkados se genera un array de condiciones de tipo column_name = value
 * @param {*} checkboxesValues
 * @param {*} column_name
 * @param {*} actual_conditions
 * @returns
 */
export const generateEqualConditions = (checkboxesValues, column_name, actual_conditions) => {
  const condiciones = Object.entries(checkboxesValues)
    .filter((entrie) => entrie[1]["checked"])
    .map((entrie2) => {
      if (entrie2[0] === "null") {
        return `${column_name}| ${column_name} is ${entrie2[0]} `;
      }

      return `${column_name}| ${column_name} = '${entrie2[0]}' `;
    });
  const condicionesSiTodoChecado =
    condiciones.length == Object.keys(checkboxesValues).length
      ? []
      : condiciones.length === 0
      ? [`${column_name}| 1 = 2 `]
      : condiciones;

  //verificar las condiciones de esta columna, limpiarlas en las condiciones originales
  const cleanActualConditions = actual_conditions.filter(
    (condition) => !condition.includes(`${column_name}|`)
  );

  return [...new Set([...condicionesSiTodoChecado, ...cleanActualConditions])];
};

export const generateRangeConditions = (checkboxesValues, column_name, bins, actual_conditions) => {
  const condiciones = Object.entries(checkboxesValues)
    .filter((entrie) => entrie[1]["checked"])
    .map((entrie2) => {
      const limites = bins[entrie2[0]];

      if (limites[0] === null) {
        return `${column_name}| ${column_name} is ${limites[0]} `;
      }

      const use_limit_down = limites[0] !== "MIN_VALUE" && !isNaN(limites[0]);
      const use_limit_up = limites[1] !== "MAX_VALUE" && !isNaN(limites[1]);

      if (use_limit_down && use_limit_up) {
        return `${column_name}| (${column_name} > ${limites[0]} and ${column_name} <= ${limites[1]}) `;
      } else if (!use_limit_down && use_limit_up) {
        return `${column_name}| ${column_name} <= ${limites[1]} `;
      } else if (use_limit_down && !use_limit_up) {
        return `${column_name}| ${column_name} > ${limites[0]} `;
      }
      //return `${column_name}| ${column_name} = '${entrie2[0]}' `
    });
  const condicionesSiTodoChecado =
    condiciones.length == Object.keys(checkboxesValues).length
      ? []
      : condiciones.length === 0
      ? [`${column_name}| 1 = 2 `]
      : condiciones;

  //verificar las condiciones de esta columna, limpiarlas en las condiciones originales
  const cleanActualConditions = actual_conditions.filter(
    (condition) => !condition.includes(`${column_name}|`)
  );

  return [...new Set([...condicionesSiTodoChecado, ...cleanActualConditions])];
};

export const generateCvegeoConditions = (claves, column_name, modo, actual_conditions) => {
  const condiciones = claves.map((clave) => {
    let condicion = "";
    condicion = modo === "estatal" ? ` strSubstring(${column_name},0,2) = '${clave}' ` : condicion;
    condicion = modo === "municipal" ? ` ${column_name} = '${clave}' ` : condicion;
    return `${column_name}|${condicion}`;
  });
  //const condicionesSiTodoChecado = condiciones.length == Object.keys(checkboxesValues).length
  //  ? [] : (condiciones.length === 0 ? [`${column_name}| 1 = 2 `]: condiciones)

  //verificar las condiciones de esta columna, limpiarlas en las condiciones originales
  const cleanActualConditions = actual_conditions.filter(
    (condition) => !condition.includes(`${column_name}|`)
  );

  return [...new Set([...condiciones, ...cleanActualConditions])];
};

const getBinCuantitativeData = (ranges, value) => {
  //console.log(ranges,value)
  return ranges.findIndex((limites) => {
    if (limites[0] === null) {
      // console.log(value);
      if (value === limites[0]) {
        return true;
      }
    }

    const use_limit_down = limites[0] !== "MIN_VALUE" && !isNaN(limites[0]);
    const use_limit_up = limites[1] !== "MAX_VALUE" && !isNaN(limites[1]);

    if (use_limit_down && use_limit_up) {
      if (value > limites[0] && value <= limites[1]) {
        return true;
      }
    } else if (!use_limit_down && use_limit_up) {
      if (value <= limites[1]) {
        return true;
      }
    } else if (use_limit_down && !use_limit_up) {
      if (value > limites[0]) {
        return true;
      }
    }
    return false;
  });
};
